import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Div from '../Page/Div';
import { sanitize } from '../../utils';
import AccordionPanel from '../UI/AccordionPanel';
const AccordionSection = ({ content, idx, allowOpen, }) => {
    const { title, accordion } = content.accordion;
    return (_jsxs("div", { className: "accordion-section", children: [_jsx(Div, { className: "accordion-title", delay: 0, children: title }), _jsx(Div, { className: "accordion-container", delay: 1, children: accordion?.map((element) => {
                    const { title, column } = element;
                    return (_jsx(AccordionPanel, { title: title, children: column?.map((col) => {
                            const { title, details } = col;
                            return (_jsx("div", { className: "accordion-column", children: !details ? null : (_jsxs(_Fragment, { children: [_jsx("div", { className: "accordion-column-title", children: title }), _jsx("div", { className: "accordion-column-details alt-font", dangerouslySetInnerHTML: {
                                                __html: sanitize(details),
                                            } })] })) }, title));
                        }) }, title));
                }) })] }));
};
export default AccordionSection;
